

import { AbortController } from 'umi-request';

class Signal {

  controller: any;

  constructor() {
    this.controller = null;
  }

  getController() {
    this.controller = new AbortController();
    return this.controller
  }
}

const signal = new Signal();
export default signal;
